export default __webpack_public_path__ + "static/media/Yenepoya Photos-5.24861ca0.png";